import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "layout-container"
};
const _hoisted_2 = {
  class: "nav-bar"
};
const _hoisted_3 = {
  class: "nav-links"
};
const _hoisted_4 = {
  class: "nav-right"
};
const _hoisted_5 = {
  class: "user-dropdown"
};
const _hoisted_6 = {
  class: "main-content"
};
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ArrowDown, Bell } from '@element-plus/icons-vue';
import { useUserinfoStore } from '@/store/userinfo';
import { useUserStore } from '@/stores/user';
import request from '@/utils/request';
import { useNotificationStore } from '@/stores/notification';
export default /*@__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {
    const router = useRouter();
    const userStore = useUserinfoStore();
    const userInfoStore = useUserStore();
    const notificationStore = useNotificationStore();
    // 获取未读消息数量（已由store自动统计，无需单独请求）
    // 退出登录
    const handleLogout = async () => {
      try {
        await request.post('/user/logout');
      } catch (e) {
        // 忽略错误，继续清理本地信息
      }
      userStore.clearUserInfo();
      userInfoStore.clearUserInfo();
      router.push('/login');
    };
    onMounted(async () => {
      // 确保用户信息已加载
      if (!userInfoStore.isLoaded) {
        await userInfoStore.fetchUserInfo();
      }
      // 拉取通知数据，统计未读数
      await notificationStore.fetchNotifications();
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_badge = _resolveComponent("el-badge");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "site-title",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push('/home'))
      }, "BUU校园墙"), _createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
        to: "/home",
        class: "nav-link"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("首页")])),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/profile",
        class: "nav-link"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("我的动态")])),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_router_link, {
        to: "/notifications",
        class: "notification-link"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_badge, {
          value: _unref(notificationStore).unreadCount > 0 ? _unref(notificationStore).unreadCount : '',
          "is-dot": _unref(notificationStore).unreadCount > 0,
          class: "notification-badge"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "notification-icon"
          }, {
            default: _withCtx(() => [_createVNode(_unref(Bell))]),
            _: 1
          })]),
          _: 1
        }, 8, ["value", "is-dot"])]),
        _: 1
      }), _createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: _cache[1] || (_cache[1] = $event => _unref(router).push('/user-info'))
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("个人信息")])),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: handleLogout
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("退出登录")])),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createTextVNode(_toDisplayString(_unref(userStore).username) + " ", 1), _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
          _: 1
        })])]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_router_view)])]);
    };
  }
});